import { updateUser } from "../../../api/repositories/updateUser";

export default {
  async update_user({ commit }, _body) {
    try {
      const data = await updateUser({ ..._body });
      commit("SET_USER", { email: data.user.email, name: data.user.email });
    } catch (error) {
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
};
